import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
const UserCardsPage = lazy(() => import('src/pages/dashboard/user/cards'));
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/user/new'));
const UserEditPage = lazy(() => import('src/pages/dashboard/user/edit'));
// LFCalculator
const LeafFilterCalculatorPage = lazy(() =>
  import('src/sections/lf-calculator/view/lf-calculator-page')
);
// Calculator Appointment
const CalculatorAppointmentView = lazy(() =>
  import('src/sections/calculator-appointment/view/calculator-appointment')
);

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        {/* <DashboardLayout> */}
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        {/* </DashboardLayout> */}
      </AuthGuard>
    ),
    children: [
      { element: <Navigate to='/appointments' replace />, index: true },
      {
        path: 'appointments',
        element: <CalculatorAppointmentView />
      },
      {
        path: '/lfcalculator',
        element: <LeafFilterCalculatorPage />
      },
      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          { path: 'cards', element: <UserCardsPage /> },
          { path: 'list', element: <UserListPage /> },
          { path: 'new', element: <UserCreatePage /> },
          { path: ':id/edit', element: <UserEditPage /> },
          { path: 'account', element: <UserAccountPage /> },
        ],
      },
    ],
  },
];
